import { useAlert } from "./AlertContext";

const AlertService = () => {
  const { showAlert } = useAlert();

  return {
    success: (message) => showAlert(message, "success"),
    error: (message, duration = 6000) => showAlert(message, "error", duration),
    info: (message) => showAlert(message, "info"),
    warning: (message) => showAlert(message, "warning"),
  };
};

export default AlertService;
